export default{name:'adduprightbtn',props:['isVisible','toBottom'],methods:{emitClick:function emitClick(){this.$emit('click')}},computed:{compIsVisible:function compIsVisible(){return this.isVisible}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/AddUprightBtn.vue
// module id = 239
// module chunks = 0